import axios from '@/axios/api.request'

export const handleLogin = (code) => axios.request({
    url: '/auth/login',
    params: { code },
    method: 'get'
  })

  export const handleWebLogin = (form) => axios.request({
    url: '/auth/web/login',
    data: form,
    method: 'post'
  })

export const getUserInfo = () => axios.request({
    url: '/auth/getUserInfo',
    method: 'get'
  })
export const logout = () => axios.request({
    url: '/auth/logout',
    method: 'get'
  })
